import clsx from "clsx";
import { useAtomValue } from "jotai";
import React, { useEffect } from "react";
import { currentTheme } from "../atoms";
import { AppThemeName, normalizeAppThemeName } from "./appTheme";
import styles from "./theme.module.css";

const themeClassByName: Record<AppThemeName, string> = {
  light: styles.beige,
  white: styles.light,
  dark: styles.dark,
  blue: styles.blue,
};

const themeClasses = Object.values(themeClassByName);

const getThemeClassName = (theme: string) => themeClassByName[normalizeAppThemeName(theme)];

export function AppThemeRoot({ children }: { children: React.ReactNode }) {
  const theme = useAtomValue(currentTheme);
  const themeClassName = getThemeClassName(theme);

  useEffect(() => {
    document.body.classList.remove(...themeClasses);
    document.body.classList.add(themeClassName);

    return () => {
      document.body.classList.remove(themeClassName);
    };
  }, [themeClassName]);

  return <div className={clsx(styles.themeRoot, themeClassName)}>{children}</div>;
}
